import { ApiProperty } from "@nestjs/swagger";

export class CompanyIdRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    username?: string;

    constructor(companyId: number, username?: string) {
        this.companyId = companyId;
        this.username = username;
    }
}